<template>
  <div id="app">
    <my-header v-show="!(name === 'meeting_data')"></my-header>
    <div class="page-mh">
      <keep-alive v-if="$route.meta.cache">
        <router-view></router-view>
      </keep-alive>
      <router-view v-else></router-view>
    </div>
    <my-footer v-show="!(name === 'meeting_data')"></my-footer>
    <fixed-msg v-show="!(name === 'meeting_data')"></fixed-msg>
  </div>
</template>s

<script>
import myHeader from "@/components/header";
import myFooter from "@/components/footer";
import fixedMsg from "@/components/leavemsg";
export default {
  name: "App",
  components: {
    myHeader,
    myFooter,
    fixedMsg,
  },
  data() {
    return {
      path: "",
      name: "",
    };
  },
  mounted() {
    this.path = this.$route.path;
    this.name = this.$route.name;
  },
  watch: {
    $route(to, from) {
      this.path = to.path;
      this.name = to.name;
    },
  },
};
</script>
